import { makeStyles } from 'makeStyles';
import { TEXT_GREY, TOOLTIP_BG } from 'theme/colors';

export const useStylesTooltip = makeStyles()((theme) => ({
  arrow: {
    color: TOOLTIP_BG,
  },
  tooltip: {
    backgroundColor: TOOLTIP_BG,
    fontSize: 14,
    fontWeight: 500,
    padding: 15,
    '& p': {
      color: theme.palette.common.white,
    },
  },
  tooltipTitle: {
    fontWeight: 500,
    marginBottom: 10,
  },
  tooltipContent: {
    fontSize: theme.typography.fontSize,
  },
  tooltipCloseIcon: {
    width: 18,
    height: 18,
    cursor: 'pointer',
    color: TEXT_GREY,
  },
}));
